import { render, staticRenderFns } from "./JobDescription.htm?vue&type=template&id=0b5bb70a&scoped=true&"
import script from "./JobDescription.ts?vue&type=script&lang=js&"
export * from "./JobDescription.ts?vue&type=script&lang=js&"
import style0 from "./JobDescription.scss?vue&type=style&index=0&id=0b5bb70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5bb70a",
  null
  
)

export default component.exports